// extracted by mini-css-extract-plugin
export var attachmentContainer = "_kg-0";
export var fileList = "_kg-2";
export var removeFileButton = "_kg-1";